import type { SearchDomain } from '@shared/types';

export type ShellDomain = Extract<
  SearchDomain,
  'projects' | 'leads' | 'tasks' | 'customers' | 'resources' | 'contracts' | 'invoices' | 'payments'
>;

export const shellDomainInvalidatedEventName = 'av:shell-domain-invalidated';

export interface ShellDomainInvalidatedDetail {
  domain: ShellDomain;
}

export function dispatchShellDomainInvalidated(domain: ShellDomain): void {
  window.dispatchEvent(
    new CustomEvent<ShellDomainInvalidatedDetail>(shellDomainInvalidatedEventName, {
      detail: { domain }
    })
  );
}

export function subscribeToShellDomainInvalidations(
  listener: (detail: ShellDomainInvalidatedDetail) => void
): () => void {
  const handler = (event: Event) => {
    listener((event as CustomEvent<ShellDomainInvalidatedDetail>).detail);
  };

  window.addEventListener(shellDomainInvalidatedEventName, handler as EventListener);
  return () => window.removeEventListener(shellDomainInvalidatedEventName, handler as EventListener);
}
